// Fully opt-in via env vars set as Heroku config vars — same pattern as
// AdSlot. With no key configured this is a no-op everywhere it's called.
// posthog-js is a sizeable dependency, so it's dynamically imported —
// nobody pays for it in their initial bundle unless a key is actually
// set (and even then, it loads in its own chunk rather than blocking
// first paint).
const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

let posthogPromise = null;

function getPosthog() {
  if (!KEY) return Promise.resolve(null);
  if (!posthogPromise) {
    posthogPromise = import("posthog-js").then(({ default: posthog }) => {
      posthog.init(KEY, { api_host: HOST });
      return posthog;
    });
  }
  return posthogPromise;
}

export function initAnalytics() {
  getPosthog();
}

export function track(event, properties) {
  getPosthog().then((posthog) => posthog?.capture(event, properties));
}
